import {Parser} from 'htmlparser2-20kb';
import StringUtils from '../StringUtils';

export class CommonReportUtils {
    static qlSmall = 'font-size: 12px;';
    static qlLarge = 'font-size: 18px;';
    static qlHuge = 'font-size: 32px;';

    // constants
    static margin = 25;
    static sectionSpacing = 45;
    static sectionSpacingLandscape = 80;
    static tFontSize = 11;
    static iFontSize = 13;
    static h1FontSize = 15;
    static h2FontSize = 12;
    static replacer = '-';
    static dFontSize = 9;
    static headerFontSize = 24;
    static lineHeight = 5;
    static footerHeigth = 10;

    static footer_x = 20;
    static footer_y = 175;

    static footer_landscape_x = 65;
    static footer_landscape_y = 175;

    static COLORS = {
        DARK_GRAY: '#2980ba',
        BLUE: '#2980ba',
        BASIC: '#1c3275',
        LIGHT: '#E8E8E8',
        RED: '#db1818',
        WHITE: '#FFFFFF',
        BLACK: '#000',
    };

    // common methods
    static addPageIfContentToLong(y, contentHeight, doc) {
        const pageHeight = doc.internal.pageSize.height;
        if (y + contentHeight + CommonReportUtils.footerHeigth >= pageHeight) {
            console.log('Add new page from addPageIfContentToLong');
            doc.addPage();
            return CommonReportUtils.margin;
        }
        return y;
    }
    static newPage(doc) {
        doc.addPage();
        return CommonReportUtils.margin;
    }
    static getValidNumber(number) {
        if (StringUtils.isBlank(number)) return 0;

        return Number(number);
    }
    static createRectWithLongText(text, x, y, w, h, doc, color) {
        const pageHeight = doc.internal.pageSize.height;

        let addNewPage = y + h + CommonReportUtils.footerHeigth >= pageHeight;
        const textWidth = doc.getTextWidth(text);
        let textLines;
        console.log(textWidth);
        if (textWidth > w && w > 0) {
            textLines = Math.ceil(textWidth / w);
            h *= textLines;
            console.log(h);
        }
        try {
            console.log('%s %s %s %s %s %s %s', text, x, y, w, h, doc, color);
            // const lineLength = doc.internal.pageSize.getWidth() - (CommonReportUtils.margin * 2);

            if (addNewPage) {
                console.log('CreateRectWithText :: add new page');
                doc.addPage();
                y = CommonReportUtils.margin;
            }
            if (color == null) {
                color = CommonReportUtils.COLORS.BASIC;
            }
            doc.setFillColor(color);
            doc.rect(x, y, w, h, 'F');
            doc.setTextColor(1, 1, 1, 1);
            if (textWidth > w && w > 0) {
                console.log('&&&&&&&&&&& - display long string');
                const currentYExt = CommonReportUtils.displayLongStringExt(
                    text,
                    x + CommonReportUtils.margin * 0.1,
                    y + h / 5,
                    w,
                    h / textLines,
                    doc,
                    'center'
                );
                y = currentYExt.y;
                if (currentYExt.newPage === true) {
                    addNewPage = true;
                }
            } else {
                console.log('@@@@@ - doc text');
                doc.text(text, x + w / 2, y + (h / 5) * 3.3, 'center');
            }
            doc.setTextColor(0, 0, 0);
            return y;
        } catch (err) {
            console.error(`Error in createRectWithText: ${err}`);
            console.log('%s %s %s %s %s %s %s', text, x, y, w, h, doc, color);
            if (color == null) {
                color = CommonReportUtils.COLORS.BASIC;
            }
            doc.setFillColor(color);
            doc.rect(x, y, w, h, 'F');
            doc.setTextColor(1, 1, 1, 1);
            if (textWidth > w && w > 0) {
                console.log('&&&&&&&&&&& - display long string');
                const currentYExt = CommonReportUtils.displayLongStringExt(text, x, y, w, h, doc);
                y = currentYExt.y;
                if (currentYExt.newPage === true) {
                    addNewPage = true;
                }
            } else {
                console.log('@@@@@ - doc text');
                doc.text(text, x + w / 2, y + (h / 5) * 3.3, 'center');
            }
            doc.setTextColor(0, 0, 0);
            return y;
        }
    }

    static createRectWithText(text, x, y, w, h, doc, color, textColor) {
        try {
            console.log(w, 'wwww');
            console.log('%s %s %s %s %s %s %s', text, x, y, w, h, doc, color);
            // const lineLength = doc.internal.pageSize.getWidth() - (CommonReportUtils.margin * 2);
            const pageHeight = doc.internal.pageSize.height;
            const addNewPage = y + h + CommonReportUtils.footerHeigth >= pageHeight;
            if (addNewPage) {
                console.log('CreateRectWithText :: add new page');
                doc.addPage();
                y = CommonReportUtils.margin;
            }
            if (color == null) {
                color = CommonReportUtils.COLORS.BASIC;
            }
            doc.setFillColor(color);
            doc.rect(x, y, w, h, 'F');
            if (textColor == null) {
                doc.setTextColor(1, 1, 1, 1);
            } else {
                doc.setTextColor(textColor);
            }
            doc.text(text, x + w / 2, y + (h / 5) * 3.3, 'center');
            doc.setTextColor(0, 0, 0);
            return y;
        } catch (err) {
            console.error(`Error in createRectWithText: ${err}`);
            console.log('%s %s %s %s %s %s %s', text, x, y, w, h, doc, color);
            if (color == null) {
                color = CommonReportUtils.COLORS.BASIC;
            }
            doc.setFillColor(color);
            doc.rect(x, y, w, h, 'F');
            doc.setTextColor(1, 1, 1, 1);
            doc.text(text, x + w / 2, y + (h / 5) * 3.3, 'center');
            doc.setTextColor(0, 0, 0);
            return y;
        }
    }

    static createSubtitle(text, x, y, fontSize, doc) {
        try {
            const lineLength = doc.internal.pageSize.getWidth() - CommonReportUtils.margin * 2;
            let valueY = y + CommonReportUtils.lineHeight;
            const addNewPage = CommonReportUtils.checkIfAddNewPage(text, y, lineLength, CommonReportUtils.lineHeight, doc);
            if (addNewPage) {
                console.log('CreateSubtitle :: add new page');
                doc.addPage();
                valueY = CommonReportUtils.margin + CommonReportUtils.lineHeight;
            }
            doc.setFontSize(fontSize * 1.7);
            doc.setFont('lato', 'bold');
            const currentY = CommonReportUtils.displayLongString(text, x, valueY, lineLength, CommonReportUtils.lineHeight, doc);
            doc.setFont('lato', 'normal');
            doc.setFontSize(fontSize);
            return currentY + CommonReportUtils.lineHeight * 0.5;
        } catch (err) {
            console.error(`Error in createSubtitle: ${err}`);
            doc.setFontSize(fontSize * 1.7);
            doc.setFont('lato', 'bold');
            doc.text(text, x, y);
            doc.setFont('lato', 'normal');
            doc.setFontSize(fontSize);
            return y + CommonReportUtils.lineHeight * 0.5;
        }
    }

    static createSubSubtitle(text, x, y, fontSize, doc) {
        doc.setFontSize(this.tFontSize);
        doc.text(text, x, y);
        doc.setFont('lato', 'normal');
        doc.setFontSize(fontSize);
    }

    // deprecated
    static titleAndDetail(title, detail, lineHeight, lineLength, x, y, tFontSize, dFontSize, doc) {
        if (detail === undefined) detail = CommonReportUtils.replacer;
        doc.setFontSize(tFontSize);
        doc.text(title, x, y);
        doc.setFontSize(dFontSize);
        return CommonReportUtils.displayLongString(detail.toString(), x, y + lineHeight, lineLength, lineHeight, doc);
    }

    static createTitleAndDetail(label, value) {
        return {
            label,
            value,
        };
    }

    static createLabelOnly(labelText) {
        return {
            label: labelText,
            value: '-|creatEmptySpace|-',
        };
    }

    static creatEmptySpace() {
        return {
            label: '',
            value: '-|creatEmptySpace|-',
        };
    }

    static arrangeInHorizontalAutoProps(y, props, doc, ...args) {
        const argCount = args.length;
        const sectionSpacing = (doc.internal.pageSize.getWidth() - CommonReportUtils.margin * 2) / argCount;
        if (props === undefined) props = {};
        if (props.tFontSize === undefined) props.tFontSize = CommonReportUtils.tFontSize;
        if (props.dFontSize === undefined) props.dFontSize = CommonReportUtils.dFontSize;
        if (props.marginLeftValue === undefined) props.marginLeftValue = CommonReportUtils.margin;
        console.log(`arrangeInHorizontalAutoProps props ${JSON.stringify(props)}`);
        return CommonReportUtils.arrangeInHorizontal(y, doc, sectionSpacing, props.tFontSize, props.dFontSize, props.marginLeftValue, args);
    }

    static arrangeInHorizontalAuto(y, doc, ...args) {
        const argCount = args.length;
        const sectionSpacing = (doc.internal.pageSize.getWidth() - CommonReportUtils.margin * 2) / argCount;
        const tFontSize = CommonReportUtils.tFontSize;
        const dFontSize = CommonReportUtils.iFontSize;
        const marginLeftValue = CommonReportUtils.margin;
        return CommonReportUtils.arrangeInHorizontal(y, doc, sectionSpacing, tFontSize, dFontSize, marginLeftValue, args);
    }

    static arrangeInHorizontalColumn(y, columnNumber, doc, ...args) {
        const sectionSpacing = (doc.internal.pageSize.getWidth() - CommonReportUtils.margin * 2) / columnNumber;
        const tFontSize = CommonReportUtils.tFontSize;
        const dFontSize = CommonReportUtils.iFontSize;
        const marginLeftValue = CommonReportUtils.margin;
        return CommonReportUtils.arrangeInHorizontal(y, doc, sectionSpacing, tFontSize, dFontSize, marginLeftValue, args);
    }

    static arrangeInHorizontal(y, doc, sectionSpacing, labelFontSize, valueFontSize, marginLeftValue, args) {
        const argCount = args.length;
        const lineHeight = CommonReportUtils.lineHeight;
        const lineLength = sectionSpacing;

        const columnMarginH = 2;
        const columnMarginV = 2;
        let labelY = y;
        let valueY = labelY + lineHeight;
        // check if add new page
        for (let i = 0; i < argCount; i++) {
            const field = args[i];
            const label = field.label;
            const value = field.value;
            console.log(`ArrangeInHorizontal :: check for field: ${label}`);
            const addNewPage = CommonReportUtils.checkIfAddNewPage(value, valueY, lineLength - columnMarginH, lineHeight, doc);
            if (addNewPage) {
                console.log('ArrangeInHorizontal :: add new page');
                doc.addPage();
                labelY = CommonReportUtils.margin;
                valueY = CommonReportUtils.margin + lineHeight;
                break;
            }
        }
        // build layout
        let maxY = 0;
        for (let i = 0; i < argCount; i++) {
            const field = args[i];
            const label = field.label;
            let value = field.value;
            const x = marginLeftValue + lineLength * i;
            if (value === undefined) value = CommonReportUtils.replacer;
            doc.setFontSize(labelFontSize);
            const labelYExt = CommonReportUtils.displayLongStringExt(label, x, labelY, lineLength - columnMarginH, lineHeight, doc);
            console.log(labelYExt);
            valueY = labelYExt.y;
            // doc.text(label, x, labelY);
            doc.setFontSize(valueFontSize);
            // let currentY;
            let currentY;
            let newPage = false;
            if (Array.isArray(value)) {
                for (const v of value) {
                    const currentYExt = CommonReportUtils.displayLongStringExt(v, x, valueY, lineLength - columnMarginH, lineHeight, doc);
                    // currentY = CommonReportUtils.displayLongString(v, x, valueY, lineLength - columnMarginH, lineHeight, doc);
                    valueY = currentYExt.y;
                    if (currentYExt.newPage === true) {
                        newPage = true;
                    }
                    currentY = currentYExt.y;
                }
            } else {
                const currentYExt = CommonReportUtils.displayLongStringExt(value, x, valueY, lineLength - columnMarginH, lineHeight, doc);
                currentY = currentYExt.y;
                if (currentYExt.newPage === true) {
                    newPage = true;
                }
            }
            if (newPage === false && currentY > maxY) {
                maxY = currentY;
            } else if (newPage === true) {
                maxY = currentY;
            }
        }
        const result = maxY + columnMarginV;
        return result;
    }

    static checkIfAddNewPage(string, yTmp, lineLength, lineHeight, doc) {
        try {
            const pageHeight = doc.internal.pageSize.height;
            if (string !== '' && string !== '-|creatEmptySpace|-' && string !== undefined) {
                console.log(`CheckIfAddNewPage :: string value = ${string} yTmp = ${yTmp}`);
                const words = doc.splitTextToSize(`${string} `, lineLength);
                for (let i = 0; i < words.length; i++) {
                    if (yTmp + lineHeight + CommonReportUtils.footerHeigth >= pageHeight) {
                        return true;
                    }
                    if (yTmp === 0) {
                        yTmp = lineHeight;
                    }
                    yTmp += lineHeight;
                }
            }
        } catch (err) {
            console.error(`Error in checkIfAddNewPage = ${err}`);
        }
        return false;
    }

    static displayLongString(string, x, y, lineLength, lineHeight, doc) {
        let yTmp = y;
        if (string !== '' && string !== '-|creatEmptySpace|-' && string !== undefined) {
            const words = doc.splitTextToSize(`${string} `, lineLength);
            for (let i = 0; i < words.length; i++) {
                yTmp = CommonReportUtils.addPageIfContentToLong(yTmp, lineHeight, doc);
                if (yTmp === 0) {
                    yTmp = lineHeight;
                }
                doc.text(words[i], x, yTmp);
                yTmp += lineHeight;
            }
        } else if (string === '-|creatEmptySpace|-') {
            doc.text('', x, yTmp);
        } else {
            doc.text(CommonReportUtils.replacer, x, yTmp);
        }
        return yTmp;
    }

    static displayLongStringExt(string, x, y, lineLength, lineHeight, doc, center) {
        let yTmp = y;
        let newPage = false;
        const pageWidth = doc.internal.pageSize.width;
        if (string !== '' && string !== '-|creatEmptySpace|-' && string !== undefined) {
            const words = doc.splitTextToSize(`${string} `, lineLength);
            for (let i = 0; i < words.length; i++) {
                yTmp = CommonReportUtils.addPageIfContentToLong(yTmp, lineHeight, doc);
                if (CommonReportUtils.margin === yTmp) {
                    newPage = true;
                }
                if (yTmp === 0) {
                    yTmp = lineHeight;
                }
                console.log(words[i]);
                if (center) {
                    const wordWidth = doc.getTextWidth(words[i]);
                    doc.text(words[i], pageWidth / 2 - wordWidth / 2, yTmp);
                } else {
                    doc.text(words[i], x, yTmp);
                }
                yTmp += lineHeight;
            }
        } else if (string === '-|creatEmptySpace|-') {
            doc.text('', x, yTmp);
        } else {
            doc.text(CommonReportUtils.replacer, x, yTmp);
        }
        return {y: yTmp, newPage};
    }

    static newLine(cursor, startX, lineHeight) {
        if (cursor.x !== startX) {
            cursor.x = startX;
            cursor.y += lineHeight;
            console.log('-->> nowa linia', cursor);
        }
        return cursor;
    }

    static cutWord(word, text) {
        if (text) {
            const start = text.indexOf(word);
            if (start === 0) {
                const result = text.substring(word.length);
                return result.trim();
            }
        }
        return text;
    }

    // testuje, czy słowo jest całe (true), czy tylko kawałek (false)
    static isCompleteWord(word, text, index) {
        if (index && index > 90) {
            return true;
        }
        if (word) {
            word = word.trim();
        }
        if (text) {
            text = text.trim();
        }
        let result;
        if (word.length === text.length) {
            result = word === text;
        } else {
            result = text.indexOf(`${word} `) === 0;
        }
        console.log(`->>> isCompleteWord, word: [${word}], text:[${text}], result=${result}`);
        if (word === '&nbsp') {
            text = '';
        }
        return result;
    }

    static replaceAll = function (target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    };

    static isEmpty(obj) {
        if (obj === undefined || obj == null) {
            return true;
        }
        for (const i in obj) {
            if (obj.hasOwnProperty(i)) return false;
        }
        return true;
    }
    static createCenteredText(text, currentXPosition, currentYPosition, width, height, doc) {
        try {
            const pageHeight = doc.internal.pageSize.height;
            const addNewPage = currentYPosition + height + CommonReportUtils.footerHeigth >= pageHeight;
            if (addNewPage) {
                doc.addPage();
                currentYPosition = CommonReportUtils.margin;
            }
            doc.text(text, currentXPosition + width / 2, currentYPosition + (height / 5) * 3.3, 'center');
            return currentYPosition;
        } catch (err) {
            console.error(`Error in createRectWithText: ${err}`);
        }
    }
    static getColor(style) {
        console.log('GET COLOR');
        if (style) {
            let attrs = style.split(';');
            attrs = attrs.filter((attr) => attr.indexOf('color') === 0);
            if (attrs.length > 0) {
                const color = attrs[0];
                const regexp = /color: rgb\(([0-9]{1,3}), ([0-9]{1,3}), ([0-9]{1,3})\)/g;
                const match = regexp.exec(color);
                if (match) {
                    return {r: parseInt(match[1]), g: parseInt(match[2]), b: parseInt(match[3])};
                }
            }
        }
        return undefined;
    }
    static indentLevelFromClass(clazz) {
        if (clazz) {
            if (clazz.indexOf('ql-indent-1') >= 0) {
                return 2;
            } else if (clazz.indexOf('ql-indent-2') >= 0) {
                return 3;
            } else if (clazz.indexOf('ql-indent-3') >= 0) {
                return 4;
            } else if (clazz.indexOf('ql-indent-4') >= 0) {
                return 5;
            }
        }
        return 1;
    }

    static liPrefix(level, attrs) {
        const counter = attrs[`li_level_${level}`];
        if (level === 1) {
            return `${counter}.`;
        } else if (level === 2) {
            return `${String.fromCharCode(96 + counter)}.`;
        }
        return '- ';
    }

    static numberFromText(txt) {
        let numb = txt.match(/\d/g);
        numb = numb.join('');
        return numb;
    }

    static displayHtml(html, x, y, lineLength, lineHeight, doc) {
        if (html === undefined) {
            html = '';
        }
        const attrs = {ol: 0};
        for (let i = 0; i < 5; i++) {
            attrs[`li_level_${i}`] = 0;
        }
        let cursor = {x, y};
        if (html === '&nbsp') {
            html = '';
        }
        const parser = new Parser(
            {
                onopentag(tagname, attribs) {
                    console.log(`>>> ${tagname} - ${JSON.stringify(attribs)}`);
                    if (tagname === 'br') {
                        attrs.p = true;
                        cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                    } else if (tagname === 'h1') {
                        attrs.h1 = true;
                        cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                    } else if (tagname === 'h2') {
                        attrs.h2 = true;
                        cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                    } else if (tagname === 'a') {
                        attrs.u = true;
                        attrs.span = true;
                        attrs.spanStyle = 'color: rgb(0, 71, 178);';
                    } else if (tagname === 'p') {
                        attrs.p = true;
                        cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                    } else if (tagname === 'strong') {
                        attrs.strong = true;
                    } else if (tagname === 'em') {
                        attrs.italic = true;
                    } else if (tagname === 's') {
                        attrs.s = true;
                    } else if (tagname === 'u') {
                        attrs.u = true;
                    } else if (tagname === 'span') {
                        attrs.span = true;
                        attrs.spanStyle = attribs.style;
                    } else if (tagname === 'ol') {
                        // attrs.ol++;
                    } else if (tagname === 'li') {
                        cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                        const level = CommonReportUtils.indentLevelFromClass(attribs.class);
                        cursor.x += level * 10;
                        attrs[`li_level_${level}`]++;
                        const prefix = CommonReportUtils.liPrefix(level, attrs);
                        doc.text(prefix, cursor.x, cursor.y);
                        const wordsX = doc.getTextWidth(prefix);
                        cursor.x += wordsX;
                    }
                },
                ontext(text) {
                    console.log(`--> ontext:[${text}]`);
                    text = CommonReportUtils.replaceAll(text, '\n', '');
                    if (text === undefined || text === null || text === '') {
                        return;
                    }
                    let currentText = text;
                    let largeFont = false;
                    let fontAlreadySet = false;
                    if (attrs.span === true) {
                        const color = CommonReportUtils.getColor(attrs.spanStyle);
                        if (color) {
                            doc.setTextColor(color.r, color.g, color.b);
                        } else {
                            doc.setTextColor(0, 0, 0);
                        }
                        if (attrs.spanStyle?.includes('font-size')) {
                            let number = parseInt(CommonReportUtils.numberFromText(attrs.spanStyle));
                            doc.setFontSize(number);
                            if (number >= 32) {
                                largeFont = true;
                            }
                            fontAlreadySet = true;
                        }
                    }

                    if (attrs.h1 === true) {
                        doc.setFontSize(CommonReportUtils.h1FontSize);
                        largeFont = true;
                    } else if (attrs.h2 === true) {
                        doc.setFontSize(CommonReportUtils.h2FontSize);
                    } else if (!fontAlreadySet) {
                        doc.setFontSize(CommonReportUtils.dFontSize);
                    }
                    if ((attrs.strong === true || attrs.bold === true) && attrs.italic === true) {
                        doc.setFont('lato', 'bold-italic');
                    } else if (attrs.strong === true || attrs.bold === true) {
                        doc.setFont('lato', 'bold');
                    } else if (attrs.italic === true) {
                        doc.setFont('lato', 'italic');
                    } else {
                        // doc.setFont('roboto', 'normal');
                    }

                    let i = 0;
                    while (true) {
                        if (i++ > 100) {
                            console.log('oj jo jo - pętelka nieskończona!');
                            break; // tak w razie co, żeby się nie zapętliło;-)
                        }
                        const testSize = lineLength - cursor.x + CommonReportUtils.margin / 2;
                        const words = doc.splitTextToSize(`${currentText} `, testSize);
                        console.log('--> ontext: words:', JSON.stringify(words));
                        console.log('--> ontext: words.length:', words.length);
                        if (words.length > 0) {
                            console.log('-->> cussor.x:', cursor.x);
                            console.log('-->> words.length:', words.length);
                            const word = words[0];
                            console.log('-->> word:', word);
                            if (word === '' || !CommonReportUtils.isCompleteWord(word, currentText, i)) {
                                cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                            } else {
                                cursor.y = CommonReportUtils.addPageIfContentToLong(cursor.y, lineHeight, doc);
                                if (y === 0) {
                                    y = lineHeight;
                                }
                                doc.text(word, cursor.x, cursor.y);
                                const wordsX = doc.getTextWidth(word);
                                if (attrs.s === true) {
                                    doc.setLineWidth(0.2); // grubośc linii
                                    doc.line(cursor.x, cursor.y - (largeFont ? 2 : 1), cursor.x + wordsX, cursor.y - (largeFont ? 2 : 1)); // przekreślenie
                                }
                                if (attrs.u === true) {
                                    doc.setLineWidth(0.2); // grubośc linii
                                    doc.line(cursor.x, cursor.y, cursor.x + wordsX, cursor.y); // podkreślenie
                                }

                                // const spaceX = doc.getTextWidth(' ');
                                // // console.log('-->> wordX:', wordsX);
                                cursor.x += wordsX; // + spaceX;
                                // // console.log('-->> cursor.x:', cursor.x);
                                if (cursor.x >= lineLength) {
                                    cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                                }
                                if (words.length === 1) {
                                    // console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ BREAK!!!!');
                                    break;
                                } else {
                                    currentText = CommonReportUtils.cutWord(word, currentText);
                                }
                            }
                        } else {
                            cursor = CommonReportUtils.newLine(cursor, x, lineHeight);
                            break;
                        }
                    }
                },
                onclosetag(tagname) {
                    console.log('<<<', tagname);
                    if (tagname === 'h1') {
                        attrs.h1 = false;
                    } else if (tagname === 'h2') {
                        attrs.h2 = false;
                    } else if (tagname === 'p') {
                        attrs.p = false;
                    } else if (tagname === 'a') {
                        attrs.u = false;
                        attrs.spanStyle = CommonReportUtils.COLORS.BASIC;
                    } else if (tagname === 'strong') {
                        attrs.strong = false;
                    } else if (tagname === 's') {
                        attrs.s = false;
                    } else if (tagname === 'u') {
                        attrs.u = false;
                    } else if (tagname === 'span') {
                        attrs.span = true;
                        attrs.spanStyle = undefined;
                        attrs.spanClass = undefined;
                    }
                    if (tagname === 'ol') {
                        for (let i = 0; i < 5; i++) {
                            attrs[`li_level_${i}`] = 0;
                        }
                    }
                },
            },
            {decodeEntities: true}
        );
        parser.write(html);
        parser.end();
        return cursor.y + lineHeight;
    }
}

export default CommonReportUtils;
